import axios from 'axios';
import qs from 'qs';
import store from '@/store/state/state.js';
import self from '../dock/index.js';
import router from '../router';
import {
  RETURN_CODE,
} from './global';

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} param [请求时携带的参数]
 */
export function post(url, param) {
  try {
    if (store.loginInfo.token.length == 0 || store.loginInfo.album_alias.length == 0) {
      self.commit('loginInfo', {
        album_alias: self.getItem('album_alias') || '',
        token: self.getItem('token') || ''
      })
    }
  } catch (err) {
    // TODO handle the exception
  }

  return new Promise((resolve, reject) => {
    axios({
        url: `/api${url}`, // https://near.us-msc.com/app.php/  /api
        method: 'POST',
        data: qs.stringify(param),
        headers: {
          albumAlias: store.loginInfo.album_alias,
          token: store.loginInfo.token,
          version: store.version,
          model: store.model,
          link: location.href,
        },
      }).then((res) => {
        // 判断状态码是不是 200 (成功)
        if (res.data.code == RETURN_CODE.success) {
          resolve(res.data);
        } else if (res.data.code == 401) {
          // 没有登录,跳转微信登录界面
          self.Message('提示', res.data.msg).then((data) => {
            if (res) {
              router.push({
                path: '/contactCatalog/progeny/signIn',
              });
            }
          });
        } else if (res.data.code == 2) {
          if (res) {
            router.push({
              path: '/',
            });
            setTimeout(() => {
              store.loginInfo.album_alias = '';
              window.location.href = `${res.data.data.url}`;
            }, 50);
          }
        } else {
          // 显示错误信息
          self.hidload();
          self.Message('提示', res.data.msg).then((data) => {

          });
        }
      })
      .catch((error) => {
        if (error.response.status == 500 || error.response.status == 502) {
          setTimeout(() => {
            location.reload();
          }, 3000)
          return;
        }
        self.Message('提示', error).then((data) => {
          console.log(data);
        });
      });
  });
}

export function upload(url, param) {
  return new Promise((resolve, reject) => {
    axios({
        url: `/api${url}`, // https://near.us-msc.com/app.php/  /api
        method: 'POST',
        data: param,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        self.Message('提示', error).then((data) => {
          console.log(data);
        });
      });
  });
}
